import config from '../config'

const managerGql = config.urls.graphql

const gqlQuery = async (query, queryName) => {
    // console.log(queryName, query)
    const response = await fetch(managerGql, { method: 'POST', body: JSON.stringify({ query: query }), headers: { 'Content-Type': 'application/json' } });
    const resJson = await response.json();
    // console.log(queryName, response, resJson)
    return resJson?.data?.[queryName]
}

const gqlQueryWithVars = async (queryName, query, variables = {}) => {
    const body = {
        query: query,
        variables: variables
    };

    const response = await fetch(managerGql, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    });

    const resJson = await response.json();
    return resJson?.data?.[queryName];
}

const ApiUtilsFunctions = {
    gqlQuery,
    gqlQueryWithVars
}

export default ApiUtilsFunctions